import type { TRegistrationField } from './types';

// Configurable registration metadata. The backend stores values under `metadata.<key>` and knows no field list:
// removing a field hides it without deleting stored values, and a key must never be reused for another meaning.
// Changing a field's type incompatibly requires an explicit migration.
export const REGISTRATION_FIELDS: readonly TRegistrationField[] = [
  { key: 'registrationNumber', label: 'Registration number', type: 'text', searchable: true, showInTable: true },
  { key: 'applicationNumber', label: 'Application number', type: 'text', searchable: true },
  { key: 'certificateNumber', label: 'Certificate number', type: 'text', searchable: true },
  { key: 'authorityReference', label: 'Authority reference', type: 'text', searchable: true },
  { key: 'regulatoryBasis', label: 'Regulatory basis', type: 'text' },
  { key: 'authority', label: 'Authority', type: 'text' },
  { key: 'authorizedRepresentative', label: 'Authorized representative', type: 'text' },
  { key: 'localRepresentative', label: 'Local representative / agent', type: 'text' },
  { key: 'serviceProvider', label: 'Service provider', type: 'text' },
];
